<div style="display: block;height:auto;width:900px;" id="containerCompleto">
    <div id="titulo">
        <h2>Listado</h2>
        <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
    </div>
    <div id="tablaContainer">
        <table mat-table class="tabla-art" [dataSource]="dataSource" style="min-width: auto; letter-spacing: 0;">
          <ng-container *ngFor="let column of columns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef>{{ column | titlecase }}</th>
            <td mat-cell *matCellDef="let row">{{ row[column].toString() | uppercase }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns;"></tr>
        </table>
    </div>
  <mat-paginator class="paginador" [pageSizeOptions]="[10]" [length]="dataSource.data.length" [pageSize]="10" [showFirstLastButtons]="true" #paginator (page)="onPageChange($event)"></mat-paginator>
  <mat-progress-bar *ngIf="dataSource.data.length <= 0" mode="indeterminate"></mat-progress-bar>
</div>

